import React from 'react';
import { useLocation } from 'react-router-dom';
import { getAuthenticatedHeaderConfig } from '../config/headerConfig';

/**
 * Page title + subtitle for mobile only.
 * Transparent background, white text; UI matches desktop header center section.
 */
const MobilePageTitle: React.FC = () => {
  const location = useLocation();
  const config = getAuthenticatedHeaderConfig(location.pathname);

  return (
    <div
      className="lg:hidden w-full flex-shrink-0 px-3 sm:px-4 pt-2 pb-3 sm:pb-4 bg-transparent"
      style={{ maxWidth: 1280, margin: '0 auto' }}
    >
      <div className="flex flex-col items-center gap-1 sm:gap-1.5 text-center">
        <h1 className="text-white font-black italic tracking-wide text-lg sm:text-xl px-2">
          {config.title}
        </h1>
        <div className="h-0.5 w-16 sm:w-20 rounded-full flex-shrink-0 bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500" />
        <p className="text-white/60 font-semibold tracking-wider text-xs sm:text-sm px-2">
          {config.subtitle}
        </p>
      </div>
    </div>
  );
};

export default MobilePageTitle;
